import { AudioPodClient } from '../client/AudioPodClient';
import { Job } from '../types';

export class DenoiserService {
  constructor(private client: AudioPodClient) {}

  async denoiseAudio(
    audioFile: File | Blob | string,
    qualityMode: string = 'balanced',
    waitForCompletion: boolean = false,
    timeout: number = 600000
  ): Promise<any> {
    let fileData: File | Blob;
    if (typeof audioFile === 'string') {
      const fs = await import('fs');
      const fileBuffer = fs.readFileSync(audioFile);
      fileData = new Blob([fileBuffer], { type: 'audio/*' });
    } else {
      fileData = audioFile;
    }

    const job = await this.client.uploadFile<Job>('/denoiser/denoise', fileData, { quality_mode: qualityMode });

    if (waitForCompletion) {
      return this.client.waitForJobCompletion(job.id, timeout);
    }
    return { job };
  }
}
